import { timelineLog } from '@/mocks/exposure';
import { SectionHead, Tag } from './ui';

const toneMap: Record<string, 'primary' | 'accent' | 'secondary' | 'neutral'> = {
  primary: 'primary',
  accent: 'accent',
  secondary: 'secondary',
  neutral: 'neutral',
};
const dotTone: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-400',
  neutral: 'bg-secondary-300',
};

export default function LogSection() {
  return (
    <section id="log" className="mx-auto w-full max-w-[1280px] px-4 py-9 md:px-6 md:py-14">
      <div className="grid items-start gap-6 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <SectionHead no="06" title="查证日志" sub="实锤进度 · 辟谣台账 · 归档记录持续更新" more="全部日志" href="#" />
          <div className="rounded-xl border border-background-200 bg-background-50 p-5">
            <p className="text-sm font-bold text-foreground-800">本周查证概览</p>
            <div className="mt-4 grid grid-cols-2 gap-3">
              {[
                ['新增实锤', '37', 'text-primary-600', 'ri-check-double-line'],
                ['待复核材料', '12', 'text-accent-600', 'ri-timer-line'],
                ['辟谣标注', '5', 'text-secondary-500', 'ri-shield-check-line'],
                ['归档合集', '9', 'text-foreground-600', 'ri-folder-2-line'],
              ].map(([label, num, color, icon], i) => (
                <div key={i} className="rounded-lg bg-background-100 p-3.5">
                  <span className={`inline-flex items-center gap-1 text-[11px] text-foreground-500`}>
                    <i className={`${icon} ${color}`} /> {label}
                  </span>
                  <p className={`mt-1 font-serif text-2xl font-black ${color}`}>{num}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="relative lg:col-span-2">
          <div className="absolute bottom-3 left-2 top-3 w-px bg-background-200 md:left-3" />
          <ol className="flex flex-col gap-4 md:gap-5">
            {timelineLog.map((l, i) => (
              <li key={i} className="relative flex gap-4 pl-8 md:pl-12">
                <span
                  className={`absolute left-1 top-1.5 h-3.5 w-3.5 rounded-full ring-4 ring-background-100 ${dotTone[l.tone]} md:left-2`}
                />
                <div className="min-w-0 flex-1 rounded-xl border border-background-200 bg-background-50 p-4 transition hover:border-background-300">
                  <div className="flex flex-wrap items-center gap-2">
                    <Tag tone={toneMap[l.tone]}>{l.type}</Tag>
                    <span className="text-[11px] text-foreground-400">{l.time}</span>
                  </div>
                  <h4 className="mt-2 font-serif text-base font-bold leading-snug text-foreground-900">
                    {l.title}
                  </h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{l.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}